var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"i-chip payment",style:({ color:  _vm.colorAndText.color}),attrs:{"outlined":"","color":_vm.colorAndText.color,"text-color":"#fff","x-small":""}},[_vm._v(_vm._s(_vm.colorAndText.text))])}
var staticRenderFns = []

export { render, staticRenderFns }